module.exports = __webpack_public_path__ + "static/media/cross.ffcfb42b.svg";